import {
  subMenuUrlsInterface,
  SubMenuDataInterface,
  responseInterface,
} from "@/types";
import {
  httpClient,
  HttpClientGetParameters,
} from "@/apiClient/models/http/httpClient.models";

export interface MenuApiClientInterface {
  fetch: (lang?: string) => Promise<responseInterface>;
  fetchSubMenu: () => Promise<SubMenuDataInterface>;
}

export class MenuApi implements MenuApiClientInterface {
  private readonly urls!: subMenuUrlsInterface;

  constructor(urls: subMenuUrlsInterface) {
    this.urls = urls;
  }

  fetch(lang?: string): Promise<responseInterface> {
    const url = this.urls.fetch.replace("{%lang%}", lang as string);

    const getParameters: HttpClientGetParameters = {
      url: url,
      requiresToken: false,
    };

    return httpClient.get<responseInterface>(getParameters);
  }

  fetchSubMenu(): Promise<SubMenuDataInterface> {
    const getParameters: HttpClientGetParameters = {
      url: this.urls.fetchSubMenu,
      requiresToken: true,
    };

    return httpClient.get<SubMenuDataInterface>(getParameters);
  }
}
